import React, { useEffect, useId, useState } from "react";
import { Popover } from "antd";
import Icons from "components/icons";
import { Localize } from "components/service";
import { getStaffScanLocationGuidance } from "../helpers/staff-scan-location-guidance-helper";


const StaffScanLocationGuidance = ({ scan, zone }) => {
    const [ visible, setVisible ] = useState(false);
    const contentID = useId();
    const guidance = getStaffScanLocationGuidance({ scan, zone });

    useEffect(() => setVisible(false), [ scan, zone ]);

    useEffect(() => {
        if (!visible)
        {
            return undefined;
        }

        // The popover is portalled outside the modal. Dismiss it before the
        // modal handles Escape, including when it was opened with the mouse.
        const handleEscape = (event) => {
            if (event.key === "Escape")
            {
                event.preventDefault();
                event.stopPropagation();
                setVisible(false);
            }
        };

        document.addEventListener("keydown", handleEscape, true);
        return () => document.removeEventListener("keydown", handleEscape, true);
    }, [ visible ]);

    return (
        <Popover
            visible={ visible }
            onVisibleChange={ setVisible }
            trigger={ [ "hover", "focus", "click" ] }
            placement="bottomLeft"
            overlayClassName="staff-scan-guidance-popover"
            destroyTooltipOnHide={ true }
            content={
                <div id={ contentID } className="staff-scan-guidance-popover__content">
                    <strong>
                        <Localize>{ `STAFF_MANAGEMENT.ScanGuidance_Title_${ guidance.scenario }` }</Localize>
                    </strong>
                    <p>
                        <Localize { ...guidance.values }>
                            { `STAFF_MANAGEMENT.ScanGuidance_Fact_${ guidance.fact }` }
                        </Localize>
                    </p>
                    <div className="staff-scan-guidance-popover__action">
                        <strong>
                            <Localize>{ `STAFF_MANAGEMENT.ScanGuidance_Audience_${ guidance.audience }` }</Localize>
                        </strong>
                        <span>
                            <Localize>{ `STAFF_MANAGEMENT.ScanGuidance_Action_${ guidance.action }` }</Localize>
                        </span>
                    </div>
                </div>
            }>
            <button
                type="button"
                className="staff-scan-location-modal__accuracy-info"
                aria-expanded={ visible }
                aria-describedby={ visible ? contentID : undefined }
                aria-controls={ visible ? contentID : undefined }>
                <Icons.StaffInfo aria-hidden="true" />
                <span className="visually-hidden">
                    <Localize>STAFF_MANAGEMENT.ScanGuidance_Label</Localize>
                </span>
            </button>
        </Popover>
    );
};

export default StaffScanLocationGuidance;
